import { BbitLanguage, BbitTranslationType, IBbitTranslation } from '@bbitgmbh/bbit.utils';

export const translations: IBbitTranslation[] = [
  {
    key: 'notInStock',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Lieferfrist auf Anfrage',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Delivery time on request',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Délai de livraison sur demande',
      },
    },
  },
  {
    key: 'reserved',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Reserviert',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Reserved',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réservé',
      },
    },
  },
  {
    key: 'checkSpamText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Bitte überprüfe auch deinen Spam-Ordner, falls du keine entsprechende E-Mail findest.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please also check your spam folder if you cannot find a corresponding e-mail.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vérifie également ton dossier spam si tu ne trouves pas d`e-mail correspondant.',
      },
    },
  },
  {
    key: 'yourReservation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ihre Reservation',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Your reservation',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Votre réservation',
      },
    },
  },
  {
    key: 'companion',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Begleitpersonen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Companions',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Accompagnateurs',
      },
    },
  },
  {
    key: 'errorLoading',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Fehler beim laden der Daten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Error loading the data.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Erreur lors du chargement des données.',
      },
    },
  },
  {
    key: 'enterNewAccompanyingPerson',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Neue Begleitperson erfassen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Enter new accompanying person',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Saisir une nouvelle personne accompagnante',
      },
    },
  },
  {
    key: 'edit',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bearbeiten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Edit',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Èditer',
      },
    },
  },
  {
    key: 'salutation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Anrede',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Salutation',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Titre de civilité',
      },
    },
  },
  {
    key: 'givenName',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Vorname',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Given name',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Prénom',
      },
    },
  },
  {
    key: 'familyName',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Nachname',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Family name',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nom de famille',
      },
    },
  },
  {
    key: 'polyhall',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Polyhalle (1. OG)',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Poly-hall (1st floor)',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Poly-salle (1er étage)',
      },
    },
  },
  {
    key: 'shootingCellar',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: '100m / 25m Schiesskeller (UG)',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: '100m / 25m shooting range (basement)',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: '100m / 25m Cave de tir (sous-sol)',
      },
    },
  },
  {
    key: 'shootingCellarDesignation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Statisch nutzbar, ideal zum Training von Langwaffen.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Statically usable, ideal for training long guns.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Utilisable en statique, idéal pour l`entraînement aux armes longues.',
      },
    },
  },
  {
    key: 'polyhallDesignation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Statisch und dynamisch nutzbar. Als zusätzliches Equipment sind Fall- und Schwenkziele aus Kunststoff (nicht splitternd), div. Barrikaden & Hindernisse sowie mobile Kugelfänge vorhanden.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Statically and dynamically usable. Additional equipment includes falling and swinging targets made of plastic (non-splintering), various barricades & obstacles and mobile bullet traps.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Utilisable de manière statique et dynamique. Comme équipement supplémentaire, il y a des cibles tombantes et pivotantes en plastique (non éclatantes), diverses barricades & obstacles ainsi que des pare-balles mobiles.',
      },
    },
  },
  {
    key: 'trainingRoom',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schulungsraum/Theorieraum (1. OG)',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Training room/theory room (1st floor)',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Salle de formation/salle de théorie (1er étage)',
      },
    },
  },
  {
    key: 'trainingRoomDesignation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Als Auffrischung bei zu trockener Theorie befindet sich daneben ein Aufenthaltsraum mit Snackautomat & Kaffeemaschine.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'As a refresher if the theory is too dry, there is a lounge next to it with a snack machine & coffee machine.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Pour se rafraîchir en cas de théorie trop sèche, une salle de séjour avec distributeur de snacks & machine à café se trouve à côté.',
      },
    },
  },
  {
    key: 'street',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Strasse',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Street',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Rue',
      },
    },
  },
  {
    key: 'postalCode',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'PLZ',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Postal code',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Code postal',
      },
    },
  },
  {
    key: 'locality',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ort',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Locality',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Lieu',
      },
    },
  },
  {
    key: 'mobile',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Mobiltelefon',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Mobile',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Téléphone portable',
      },
    },
  },
  {
    key: 'eMail',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'E-Mail',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'E-Mail',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Courrier électronique',
      },
    },
  },
  {
    key: 'recordAccompanyingPerson',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Begleitperson erfassen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Record accompanying person',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Saisir la personne accompagnante',
      },
    },
  },
  {
    key: 'mandatoryFields',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Pflichtfelder',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Mandatory fields',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Champs obligatoires',
      },
    },
  },
  {
    key: 'editAccompanyingPerson',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Begleitperson bearbeiten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Edit accompanying person',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Modifier l`accompagnateur',
      },
    },
  },
  {
    key: 'noAccompanyingPersonsRecorded',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Keine Begleitpersonen erfasst',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'No accompanying persons recorded',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Aucun accompagnateur recensé',
      },
    },
  },
  {
    key: 'save',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Speichern',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Save',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Enregistrer',
      },
    },
  },
  {
    key: 'delete',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Löschen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Delete',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Supprimer',
      },
    },
  },
  {
    key: 'errorBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Fehler beim Erstellen der Buchung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Error while creating the booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Erreur lors de la création de l`écriture',
      },
    },
  },
  {
    key: 'cancellationError',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Fehler beim Stornieren der Buchung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Error while canceling the booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Erreur lors de l`annulation de la réservation',
      },
    },
  },
  {
    key: 'pleaseWait',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bitte warten...',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please wait...',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Veuillez patienter...',
      },
    },
  },
  {
    key: 'close',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schliessen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Close',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Fermer',
      },
    },
  },
  {
    key: 'cancel',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stornieren',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Cancel',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Annuler',
      },
    },
  },
  {
    key: 'abort',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Abbrechen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Abort',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Abandonner',
      },
    },
  },
  {
    key: 'noBookingAvailable',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Keine Buchungen vorhanden',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'No booking available',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Aucune réservation disponible',
      },
    },
  },
  {
    key: 'cancellationNotPossible',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stornierung nicht möglich',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Cancellation not possible',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'L`annulation n`est pas possible',
      },
    },
  },
  {
    key: 'cancelBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Buchung stornieren',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Cancel booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Annuler la réservation',
      },
    },
  },
  {
    key: 'cancellationSuccess',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ihre Buchung wurde erfolgreich storniert',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Your booking has been successfully canceled',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Votre réservation a été annulée avec succès',
      },
    },
  },
  {
    key: 'cancellationConfirmation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Sie erhalten in Kürze eine Bestätigung der Stornierung per E-Mail',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'You will shortly receive a confirmation of the cancellation by e-mail',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vous recevrez sous peu une confirmation d`annulation par e-mail',
      },
    },
  },
  {
    key: 'placeBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Platzbuchungen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Place bookings',
      },
    },
  },
  {
    key: 'blocked',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Blockiert',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Blocked',
      },
    },
  },
  {
    key: 'comboboxNewEntry',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Neuen Eintrag hinzufügen...',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Add new entry...',
      },
    },
  },
  {
    key: 'comboboxNoRowsFound',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Keine Zeilen gefunden...',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'No rows found...',
      },
    },
  },
  {
    key: 'shootingRange',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schiessanlage',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Shooting Range',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Stand de tir',
      },
    },
  },
  {
    key: 'shootingRangeOpen',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Top ausgerüstete Schiesskeller mit modernen Zugscheiben und rund 20 unterschiedlichen Schiessprogrammen.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Top equipped shooting cellar with modern moving targets and around 20 different shooting programs.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Cave de tir bien équipée avec des cibles mobiles modernes et environ 20 programmes de tir différents.',
      },
    },
  },
  {
    key: 'offers',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Angebote',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Offers',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Offres',
      },
    },
  },
  {
    key: 'error',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Fehler',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Error',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Erreur',
      },
    },
  },
  {
    key: 'optionTitle',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: '%0',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: '%0',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: '%0',
      },
    },
  },
  {
    key: 'optionDesignation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: '%0',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: '%0',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: '%0',
      },
    },
  },
  {
    key: 'book',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Buchen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Book',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réserver',
      },
    },
  },
  {
    key: 'noPermission',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Keine Freigabe',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'No Permission',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Pas de permission',
      },
    },
  },
  {
    key: 'approvalPending',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Freigabe wird geprüft',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Approval Pending',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Approbation en attente',
      },
    },
  },
  {
    key: 'approvalPendingMessage',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Deine Freigabe wird von uns geprüft, wir setzen uns in Kürze mit dir in Verbindung.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Your approval is being reviewed by us, we will contact you shortly.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Votre approbation est en cours de révision par nos soins, nous vous contacterons sous peu.',
      },
    },
  },
  {
    key: 'missingApproval',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Fehlende Freigabe',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Missing Approval',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Approbation manquante',
      },
    },
  },
  {
    key: 'missingApprovalMessage',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Du hast aktuell keine Freigabe, um Buchen zu erstellen. Um fortzufahren, fülle Bitte alle nötigen Daten aus',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'You currently do not have approval to create bookings. To continue, please fill in all the necessary data',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Vous n`avez actuellement pas l`approbation pour créer des réservations. Pour continuer, veuillez remplir toutes les données nécessaires',
      },
    },
  },
  {
    key: 'fillData',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Daten ausfüllen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Fill Data',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Remplir les données',
      },
    },
  },
  {
    key: 'pleaseLogin',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bitte logge dich ein, um die Angebote zu sehen.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please log in to see the offers.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Veuillez vous connecter pour voir les offres.',
      },
    },
  },
  {
    key: 'login',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Login',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Login',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Connexion',
      },
    },
  },
  {
    key: 'onlineBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Online-Buchung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Online Booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réservation en ligne',
      },
    },
  },
  {
    key: 'approvalInProgress',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Deine Freigabe befindet sich zur Zeit in Bearbeitung.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Your approval is currently being processed.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Votre approbation est actuellement en cours de traitement.',
      },
    },
  },
  {
    key: 'weWillContactYou',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Wir melden uns in Kürze bei dir.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'We will contact you shortly.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nous vous contacterons sous peu.',
      },
    },
  },
  {
    key: 'alreadyHaveAccount',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Du hast bereits einen von uns freigegeben Account?',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Do you already have an account approved by us?',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Avez-vous déjà un compte approuvé par nous?',
      },
    },
  },
  {
    key: 'pleaseLoginToContinue',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bitte melde dich an um mit der Buchung fortzufahren.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please log in to continue with the booking.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Veuillez vous connecter pour continuer la réservation.',
      },
    },
  },
  {
    key: 'additionalInfoRequired',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Um deine Anmeldung zur Nutzung unserer Schiessanlagen abzuschliessen, benötigen wir noch zusätzliche Informationen. Bitte schliesse den nachfolgenden Schritt für Schritt Prozess ab. Falls du diesen abbrichst, startest du beim nächsten Mal, beim letzten noch nicht abgeschlossenen Schritt.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'To complete your registration for using our shooting ranges, we need additional information. Please complete the following step-by-step process. If you abort it, you will start at the last unfinished step next time.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Pour compléter votre inscription à l`utilisation de nos stands de tir, nous avons besoin d`informations supplémentaires. Veuillez compléter le processus étape par étape suivant. Si vous l`abandonnez, vous commencerez la prochaine fois à la dernière étape non terminée.',
      },
    },
  },
  {
    key: 'dragOrClickToUpload',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Datei hierhin ziehen oder klicken',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Drag or click to upload file',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Faites glisser ou cliquez pour télécharger le fichier',
      },
    },
  },
  {
    key: 'alreadyUploadedFiles',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Du hast bereits folgende Dateien hochgeladen:',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'You have already uploaded the following files:',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vous avez déjà téléchargé les fichiers suivants:',
      },
    },
  },
  {
    key: 'clickHereToViewFile',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Klicke hier, um die Datei anzuzeigen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Click here to view the file',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Cliquez ici pour voir le fichier',
      },
    },
  },
  {
    key: 'iAgree',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ich bin einverstanden',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'I agree',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Je suis d`accord',
      },
    },
  },
  {
    key: 'enterPossibleDates',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bitte gib hier mögliche Termine an',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please enter possible dates here',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Veuillez entrer les dates possibles ici',
      },
    },
  },
  {
    key: 'completeRegistration',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Anmeldung abschliessen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Complete registration',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Compléter l`inscription',
      },
    },
  },
  {
    key: 'facilityClosed',
    text: {
      [BbitLanguage.DE_CH]: { [BbitTranslationType.PLURAL]: 'Die Anlage ist am %0 geschlossen' },
      [BbitLanguage.EN_US]: { [BbitTranslationType.PLURAL]: 'The facility is closed on %0' },
      [BbitLanguage.FR_CH]: { [BbitTranslationType.PLURAL]: "L'installation est fermée le %0" },
    },
  },
  {
    key: 'facilityBlocked',
    text: {
      [BbitLanguage.DE_CH]: { [BbitTranslationType.PLURAL]: 'Die Anlage ist für Buchungen am %0 gesperrt' },
      [BbitLanguage.EN_US]: { [BbitTranslationType.PLURAL]: 'The facility is blocked for bookings on %0' },
      [BbitLanguage.FR_CH]: { [BbitTranslationType.PLURAL]: "L'installation est bloquée pour les réservations le %0" },
    },
  },
  {
    key: 'currentCredit',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Aktuelles Guthaben',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Current credit',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Crédit actuel',
      },
    },
  },
  {
    key: 'requiredCredit',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Benötigtes Guthaben',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Required credit',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Crédit requis',
      },
    },
  },
  {
    key: 'newCredit',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Neues Guthaben',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'New credit',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nouveau crédit',
      },
    },
  },
  {
    key: 'topUpCredit',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Hier kannst du dein Guthaben aufladen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'You can top up your credit here',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vous pouvez recharger votre crédit ici',
      },
    },
  },
  {
    key: 'acceptConditions',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Um die Buchung abzuschliessen, müssen folgende Bedingungen akzeptiert werden:',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'To complete the booking, the following conditions must be accepted:',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Pour finaliser la réservation, les conditions suivantes doivent être acceptées:',
      },
    },
  },
  {
    key: 'generalTerms',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Allgemeine Bestimmungen für die Schiessanlage',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'General terms and conditions for the shooting range',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Conditions générales d'utilisation du stand de tir",
      },
    },
  },
  {
    key: 'generalTermsPdf',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Allgemeine Bestimmungen für die Schiessanlage.pdf',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'General terms and conditions for the shooting range.pdf',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Conditions générales d'utilisation du stand de tir.pdf",
      },
    },
  },
  {
    key: 'download',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'herunterladen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'download',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'télécharger',
      },
    },
  },
  {
    key: 'bookingDuration',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Dauer der Buchung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Booking duration',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Durée de la réservation',
      },
    },
  },
  {
    key: 'paymentMethod',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Zahlungsmethode',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Payment method',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Mode de paiement',
      },
    },
  },
  {
    key: 'companionCount',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Begleitpersonen (%0/%1)',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Companions (%0/%1)',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Accompagnateurs (%0/%1)',
      },
    },
  },
  {
    key: 'addCompanion',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Begleitperson hinzufügen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Add companion',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Ajouter un accompagnateur',
      },
    },
  },
  {
    key: 'recordNewCompanion',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Neue Begleitperson erfassen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Add new companion',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Enregistrer un nouvel accompagnateur',
      },
    },
  },
  {
    key: 'allowedUsageTypes',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Erlaubte Nutzungsarten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Allowed usage types',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Types d'utilisation autorisés",
      },
    },
  },
  {
    key: 'priceInclVat',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Preis inkl. MWST',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Price incl. VAT',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Prix TVA incluse',
      },
    },
  },
  {
    key: 'priceCalculationError',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Fehler beim Berechnen des Preises',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Error calculating price',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Erreur lors du calcul du prix',
      },
    },
  },
  {
    key: 'noMoreFiles',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ich habe keine weitere Dateien',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'I have no more files',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Je n'ai plus de fichiers",
      },
    },
  },
  {
    key: 'bookingOverlaySuccessTitle',
    text: {
      [BbitLanguage.DE_CH]: { [BbitTranslationType.PLURAL]: 'Ihre Buchung wurde erfolgreich erstellt' },
      [BbitLanguage.EN_US]: { [BbitTranslationType.PLURAL]: 'Your booking has been successfully created' },
      [BbitLanguage.FR_CH]: { [BbitTranslationType.PLURAL]: 'Votre réservation a été créée avec succès' },
    },
  },
  {
    key: 'bookingOverlaySuccessEmail',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Sie erhalten in Kürze eine Bestätigung Ihrer Buchung per E-Mail',
      },
      [BbitLanguage.EN_US]: { [BbitTranslationType.PLURAL]: 'You will soon receive a booking confirmation by email' },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vous recevrez bientôt une confirmation de réservation par e-mail',
      },
    },
  },
  {
    key: 'bookingOverlayClose',
    text: {
      [BbitLanguage.DE_CH]: { [BbitTranslationType.PLURAL]: 'Schliessen' },
      [BbitLanguage.EN_US]: { [BbitTranslationType.PLURAL]: 'Close' },
      [BbitLanguage.FR_CH]: { [BbitTranslationType.PLURAL]: 'Fermer' },
    },
  },
  {
    key: 'bookingOverlayErrorCreatingBooking',
    text: {
      [BbitLanguage.DE_CH]: { [BbitTranslationType.PLURAL]: 'Fehler beim Erstellen der Buchung' },
      [BbitLanguage.EN_US]: { [BbitTranslationType.PLURAL]: 'Error creating booking' },
      [BbitLanguage.FR_CH]: { [BbitTranslationType.PLURAL]: 'Erreur lors de la création de la réservation' },
    },
  },
  {
    key: 'bookingOverlayRedirectPayment',
    text: {
      [BbitLanguage.DE_CH]: { [BbitTranslationType.PLURAL]: 'Sie werden in Kürze zur Zahlungsseite weitergeleitet...' },
      [BbitLanguage.EN_US]: { [BbitTranslationType.PLURAL]: 'You will soon be redirected to the payment page...' },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vous serez bientôt redirigé(e) vers la page de paiement...',
      },
    },
  },
  {
    key: 'bookingOverlayPleaseWait',
    text: {
      [BbitLanguage.DE_CH]: { [BbitTranslationType.PLURAL]: 'Bitte warten...' },
      [BbitLanguage.EN_US]: { [BbitTranslationType.PLURAL]: 'Please wait...' },
      [BbitLanguage.FR_CH]: { [BbitTranslationType.PLURAL]: 'Veuillez patienter...' },
    },
  },
  {
    key: 'topUpCredit',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Guthaben aufladen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Top up credit',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Recharger le crédit',
      },
    },
  },
  {
    key: 'requestedCredit',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Gewünschtes Guthaben',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Requested credit',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Crédit souhaité',
      },
    },
  },
  {
    key: 'creditsAvailabilityDelay',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Es kann einige Minuten dauern, bis das Guthaben auf der Buchungsplattform verfügbar ist.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'It may take a few minutes for the credit to become available on the booking platform.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Il peut s’écouler quelques minutes avant que le crédit ne soit disponible sur la plateforme de réservation.',
      },
    },
  },
  {
    key: 'buy',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Kaufen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Buy',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Acheter',
      },
    },
  },
  {
    key: 'pleaseSetAQuantity',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bitte gib eine Anzahl an',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please enter a quantity',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Veuillez entrer une quantité',
      },
    },
  },
  {
    key: 'pleaseSelectAPaymentMethod',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bitte wähle eine Zahlungsmethode',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Please select a payment method',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Veuillez sélectionner un mode de paiement',
      },
    },
  },
  {
    key: 'createNewBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Neue Buchung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'New booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nouvelle réservation',
      },
    },
  },
  {
    key: 'changeEMail',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'E-Mail ändern',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Change e-mail',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Changer l`adresse e-mail',
      },
    },
  },
  {
    key: 'changePassword',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Passwort ändern',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Change password',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Changer le mot de passe',
      },
    },
  },
  {
    key: 'changeAddress',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Adresse ändern',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Change address',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Changer l`adresse',
      },
    },
  },
  {
    key: 'credit',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Guthaben',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Credit',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Crédit',
      },
    },
  },
  {
    key: 'knowHowFile',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ausbildungsnachweise',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Training certificates',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Certificats de formation',
      },
    },
  },
  {
    key: 'additionalKnowHowFileInfo',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Um weitere Freigaben zu erhalten, kannst du hier neue Nachweise hochladen. Wenn du ein neues Dokument hochgeladen hast, melde dich bitte bei uns, damit wir dies prüfen und dir die weiteren Freigaben erteilen können.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'To obtain further approvals, you can upload new certificates here. If you have uploaded a new document, please contact us so that we can check this and grant you the further approvals.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Pour obtenir d`autres approbations, vous pouvez télécharger de nouveaux certificats ici. Si vous avez téléchargé un nouveau document, veuillez nous contacter afin que nous puissions vérifier cela et vous accorder les autres approbations.',
      },
    },
  },
  {
    key: 'noEntries',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Keine Einträge',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'No entries',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Pas d`entrées',
      },
    },
  },
  {
    key: 'usages',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Verwendungen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Usages',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Utilisations',
      },
    },
  },
  {
    key: 'bookingNoLongerPossilbe',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Buchung nicht mehr möglich',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Booking no longer possible',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réservation plus possible',
      },
    },
  },
  {
    key: 'newBooking',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Neue Buchung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'New booking',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nouvelle réservation',
      },
    },
  },
  {
    key: 'place',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Platz',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Place',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Place',
      },
    },
  },
  {
    key: 'bookingYouHaveAnAccount',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Du hast bereits einen Account bei uns?',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Do you already have an account with us?',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Avez-vous déjà un compte chez nous?',
      },
    },
  },
  {
    key: 'welcomeTo',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Willkommen bei der',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Welcome to',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Bievenue chez',
      },
    },
  },
  {
    key: 'fullServideProvider',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ihr Rundum-Dienstleister für den Schiesssport und die Jagd.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Your full service provider for shooting sports and hunting.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Votre prestataire de services complet pour le tir sportif et la chasse.',
      },
    },
  },
  {
    key: 'news',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'News',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'News',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Actualités',
      },
    },
  },
  {
    key: 'newsFromBurgdorf',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'News aus Burgdorf',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'News from Burgdorf',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Actualités de Burgdorf',
      },
    },
  },
  {
    key: 'moreNews',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Mehr News',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'More news',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Plus d`actualités',
      },
    },
  },
  {
    key: 'store',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ladenlokal',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Store',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Magasin',
      },
    },
  },
  {
    key: 'personalAdvice',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Persönliche Beratung, Verkauf und Reparatur rund um den Schiesssport und die Jagd.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Personal advice, sales and repairs for shooting sports and hunting.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Conseils personnalisés, ventes et réparations pour le tir sportif et la chasse.',
      },
    },
  },
  {
    key: 'learnMore',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Mehr erfahren...',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Learn more...',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'En savoir plus...',
      },
    },
  },
  {
    key: 'monday',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Montag',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Monday',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Lundi',
      },
    },
  },
  {
    key: 'tuesday',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Dienstag',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Tuesday',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Mardi',
      },
    },
  },
  {
    key: 'wednesday',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Mittwoch',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Wednesday',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Mercredi',
      },
    },
  },
  {
    key: 'thursday',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Donnerstag',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Thursday',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Jeudi',
      },
    },
  },
  {
    key: 'friday',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Freitag',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Friday',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vendredi',
      },
    },
  },
  {
    key: 'saturday',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Samstag',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Saturday',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Samedi',
      },
    },
  },
  {
    key: 'sunday',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Sonntag',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Sunday',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Dimanche',
      },
    },
  },
  {
    key: 'closed',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Geschlossen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Closed',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Fermé',
      },
    },
  },
  {
    key: 'openingHoursAndDirections',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Öffnungszeiten & Anfahrt',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Opening hours & directions',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Heures d`ouverture et directions',
      },
    },
  },
  {
    key: 'contact',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Kontakt',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Contact',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Contact',
      },
    },
  },
  {
    key: 'directions',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Anfahrt',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Directions',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Accès',
      },
    },
  },
  {
    key: 'shop',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Laden',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Shop',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Magasin',
      },
    },
  },
  {
    key: 'shopDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Stöbern Sie in unserem umfangreichen Sortiment an Schiesssport- und Jagdzubehör. Sie finden bei uns Sport- und Jagdwaffen, Munition, Feldstecher, Zielfernrohre, Messer und Pfeffersprays.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Browse our extensive range of shooting sports and hunting accessories. You will find sporting and hunting firearms, ammunition, binoculars, scopes, knives, and pepper sprays.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Parcourez notre vaste gamme d`accessoires pour le tir sportif et la chasse. Vous trouverez chez nous des armes de sport et de chasse, des munitions, des jumelles, des lunettes de visée, des couteaux et des sprays au poivre.',
      },
    },
  },
  {
    key: 'workshop',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Werkstatt',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Workshop',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Atelier',
      },
    },
  },
  {
    key: 'workshopDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Unser Büchsenmacher-Team kann für Sie die schwierigsten Reperaturen an praktisch allen Waffen durchführen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Our team of gunsmiths can carry out even the most difficult repairs on virtually all types of weapons.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Notre équipe d`armuriers peut effectuer même les réparations les plus difficiles sur pratiquement tous les types d`armes.',
      },
    },
  },
  {
    key: 'visitOur',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Besuchen Sie unser',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Visit our',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Visitez notre',
      },
    },
  },
  {
    key: 'shootingRangeDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Unsere Schiessanlage ist 365 Tage im Jahr für Sie geöffnet!',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Our shooting range is open 365 days a year!',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Notre stand de tir est ouvert 365 jours par an!',
      },
    },
  },
  {
    key: 'bookingNeedAnAccount',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Du hast noch keinen Account?',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Do you not have an account yet?',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'N`avez-vous pas encore de compte?',
      },
    },
  },
  {
    key: 'bookingNeedAnAccountInfo',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Bevor du mit der Registration fortfährst, lies bitte die folgenden Dokumente durch:',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Before you continue with the registration, please read the following documents:',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Avant de continuer l`inscription, veuillez lire les documents suivants:',
      },
    },
  },
  {
    key: 'signUp',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Registrieren',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Sign up',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'S`inscrire',
      },
    },
  },
  {
    key: 'hour',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stunden',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Hours',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Heures',
      },
    },
  },
  {
    key: 'availablePerPlace',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Verfügbar pro Platz',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Available per place',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Disponibles par place',
      },
    },
  },
  {
    key: '100mUG',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: '100m Scheibe UG',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: '100m target (basement)',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: '100m cible (sous-sol)',
      },
    },
  },
  {
    key: '25mUG',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: '25m Scheibe (UG)',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: '25m target (basement)',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Cible 25m (sous-sol)',
      },
    },
  },
  {
    key: 'visitShootingRange',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Besuchen Sie unsere',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Visit our',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Visitez notre',
      },
    },
  },
  {
    key: 'shootingRangeDescriptioin',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Unsere Schiessanlage ist 365 Tage im Jahr für Sie geöffnet!',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Our shooting range is open 365 days a year!',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Notre stand de tir est ouvert 365 jours par an!',
      },
    },
  },
  {
    key: 'register',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Registrieren',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Register',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'S`inscrire',
      },
    },
  },
  {
    key: 'bookPlace',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Platz buchen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Book a place',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réserver une place',
      },
    },
  },
  {
    key: 'ourInfrastructure',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Untere Infrastruktur',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Our infrastructure',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Notre infrastructure',
      },
    },
  },
  {
    key: 'specialFeatures',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Besonderheiten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Special features',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Caractéristiques spéciales',
      },
    },
  },
  {
    key: 'independentAccess',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Selbständiger Anlagenzutritt über Fingerprintsystem',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Independent access to the facility via fingerprint system',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Accès indépendant à l`installation via un système d`empreintes digitales',
      },
    },
  },
  {
    key: 'bookableOnline',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Jederzeit online buchbar',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Bookable online at any time',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réservable en ligne à tout moment',
      },
    },
  },
  {
    key: 'specialFloorWallsAndCeiling',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Spezial Boden, Wände & Decke (rückprallsicher, rutschfest, schallabsorbierend)',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Special floor, walls & ceiling (rebound-proof, slip-resistant, sound-absorbing)',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Sol, murs et plafond spéciaux (anti-rebond, antidérapants, absorbant le son)',
      },
    },
  },
  {
    key: 'rentalWeapons',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Mietwaffen während Ladenöffnungszeiten (erfordert zusätzlichen Nachweis)',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Rental weapons during store opening hours (requires additional proof)',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Armes de location pendant les heures d`ouverture du magasin (nécessite une preuve supplémentaire)',
      },
    },
  },
  {
    key: 'powerfulVentilation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Kräftige Lüftungsanlage mit Heizung - auch im Winter angenehm!',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Powerful ventilation system with heating - comfortable even in winter!',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Système de ventilation puissant avec chauffage - confortable même en hiver!',
      },
    },
  },
  {
    key: 'dimmableLed',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Dimmbare LED Beleuchtung mit Zonensteuerung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Dimmable LED lighting with zone control',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Éclairage LED dimmable avec contrôle par zone',
      },
    },
  },
  {
    key: 'fullyAccessible',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Komplett rollstuhlgängig',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Fully wheelchair accessible',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Entièrement accessible en fauteuil roulant',
      },
    },
  },
  {
    key: 'lounge',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Aufenthaltsraum mit Snackautomat & Kaffeemaschine',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Lounge with snack machine & coffee maker',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Lounge avec distributeur de collations et machine à café',
      },
    },
  },
  {
    key: 'rooms',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Räume',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Rooms',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Chambres',
      },
    },
  },
  {
    key: 'offers',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Angebote',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Offers',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Offres',
      },
    },
  },
  {
    key: 'instructor',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Kursleiter',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Instructors',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Instructeurs',
      },
    },
  },
  {
    key: 'instructorDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Eigene sowie diverse national und international bekannte, hauptberufliche Kursleiter mit verschiedensten Ausbildungsschwerpunkten führen Ihr Kurs- & Ausbildungsangebote in unserem Schiesszentrum durch. Bitte nehmen Sie bei Interesse direkt Kontakt mit den entsprechenden Kursleitern auf.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Own as well as various nationally and internationally known, full-time instructors with various training focuses conduct your course and training offerings in our shooting center. Please contact the respective instructors directly if you are interested.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Des instructeurs professionnels, nationaux et internationaux, spécialisés dans divers domaines de formation, animent vos cours et formations dans notre centre de tir. Si vous êtes intéressé, veuillez contacter directement les instructeurs concernés.',
      },
    },
  },
  {
    key: 'instructorDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Eigene sowie diverse national und international bekannte, hauptberufliche Kursleiter mit verschiedensten Ausbildungsschwerpunkten führen Ihr Kurs- & Ausbildungsangebote in unserem Schiesszentrum durch. Bitte nehmen Sie bei Interesse direkt Kontakt mit den entsprechenden Kursleitern auf.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Own as well as various nationally and internationally known, full-time instructors with various training focuses conduct your course and training offerings in our shooting center. Please contact the respective instructors directly if you are interested.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Des instructeurs professionnels, nationaux et internationaux, spécialisés dans divers domaines de formation, animent vos cours et formations dans notre centre de tir. Si vous êtes intéressé, veuillez contacter directement les instructeurs concernés.',
      },
    },
  },
  {
    key: 'website',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Webseite',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Website',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Site Web',
      },
    },
  },
  {
    key: 'eMail',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'E-Mail',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'E-Mail',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'E-Mail',
      },
    },
  },
  {
    key: 'phone',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Telefon',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Phone',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Téléphone',
      },
    },
  },
  {
    key: 'various',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Diverses',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Various',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Divers',
      },
    },
  },
  {
    key: 'material',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Material',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Material',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Matériel',
      },
    },
  },
  {
    key: 'atYourService',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'zu Ihren Diensten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'at your service',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'à votre service',
      },
    },
  },
  {
    key: 'documents',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Dokumente',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Documents',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Documents',
      },
    },
  },
  {
    key: 'documentsDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Die Zubehör-Grafiken dürfen für Werbezwecke in unveränderter Form ohne weitere Erlaubnis verwendet werden. Als Händler können sie bei uns laminierte Hochqualitätsdrucke anfordern.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'The accessory graphics may be used for advertising purposes in their unaltered form without further permission. As a dealer, you can request laminated high-quality prints from us.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "Les graphiques d'accessoires peuvent être utilisés à des fins publicitaires dans leur forme inchangée sans autorisation supplémentaire. En tant que revendeur, vous pouvez demander des impressions haute qualité laminées auprès de nous.",
      },
    },
  },
  {
    key: 'your',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Ihr',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Your',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Votre',
      },
    },
  },
  {
    key: 'specialist',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Spezialist',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Specialist',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Spécialiste',
      },
    },
  },
  {
    key: 'forWeaponAndAccessories',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'für Waffen und Zubehör',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'for weapons and accessories',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'pour les armes et les accessoires',
      },
    },
  },
  {
    key: 'since1960',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Seit 1960 für Sie da! Geführt in der dritten Generation.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Since 1960 at your service! Run by the third generation.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Depuis 1960 à votre service ! Dirigé par la troisième génération.',
      },
    },
  },
  {
    key: 'ourActivities',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Unsere Tätigkeiten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Our activities',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nos activités',
      },
    },
  },
  {
    key: 'expertiseInVariousAreas',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Wir haben Expertise in verschiedenen Bereichen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'We have expertise in various areas',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nous avons une expertise dans divers domaines',
      },
    },
  },
  {
    key: 'productDevelopment',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Entwicklung Eigenprodukte',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Product development',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Développement de produits',
      },
    },
  },
  {
    key: 'productDevelopmentDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Wir entwickeln laufend neue Produkte im Bereich des Schiesssportes und der Jagd. Dabei hilft uns die Erfahrung als Berufsleute, als Sportschützen, als Militärangehörige und als Jäger.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'We are continuously developing new products in the field of shooting sports and hunting. Our experience as professionals, sports shooters, military personnel, and hunters helps us in this.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Nous développons en permanence de nouveaux produits dans le domaine des sports de tir et de la chasse. Notre expérience en tant que professionnels, tireurs sportifs, militaires et chasseurs nous aide dans cette tâche.',
      },
    },
  },
  {
    key: 'production',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Produktion',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Production',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Production',
      },
    },
  },
  {
    key: 'productionDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Die entwickelten Eigenprodukte werden bei uns im Haus auf Dreh- und Fräszentren selbst hergestellt und nach den entsprechenden Oberflächenbehandlungen auch montiert.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'The developed in-house products are manufactured on turning and milling centers and assembled after the corresponding surface treatments.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Les produits développés en interne sont fabriqués sur des centres de tournage et de fraisage et assemblés après les traitements de surface correspondants.',
      },
    },
  },
  {
    key: 'productionLine',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Die ganze Entwicklungs- und Herstellungslinie ist 100% Made in Switzerland.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'The entire development and production line is 100% made in Switzerland.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'La totalité de la ligne de développement et de production est 100 % fabriquée en Suisse.',
      },
    },
  },
  {
    key: 'services',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Dienstleistungen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Services',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Services',
      },
    },
  },
  {
    key: 'repairs',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Reparaturen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Repairs',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Réparations',
      },
    },
  },
  {
    key: 'service',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Service',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Service',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Service',
      },
    },
  },
  {
    key: 'maintenance',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Instandhaltung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Maintenance',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Maintenance',
      },
    },
  },
  {
    key: 'modifications',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Modifizierungen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Modifications',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Modifications',
      },
    },
  },
  {
    key: 'consulting',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Beratung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Consulting',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Consulting',
      },
    },
  },
  {
    key: 'retail',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Detailhandel / Ladengeschäft',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Retail / Store',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Commerce de détail / Magasin',
      },
    },
  },
  {
    key: 'retailDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Wir führen ein breites Sortiment an:',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'We offer a wide range of:',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nous proposons une large gamme de:',
      },
    },
  },
  {
    key: 'weapons',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Waffen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Weapons',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Armes',
      },
    },
  },
  {
    key: 'ammunition',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Munition',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Ammunition',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Munitions',
      },
    },
  },
  {
    key: 'accessories',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Zubehör',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Accessories',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Accessoires',
      },
    },
  },
  {
    key: 'wholesale',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Grosshandel',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Wholesale',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Grossiste',
      },
    },
  },
  {
    key: 'wholesaleDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Nutzen Sie als Händler unsere Kompetenz!',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Dealers can benefit from our expertise!',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Les détaillants en gros peuvent bénéficier de notre expertise!',
      },
    },
  },
  {
    key: 'shootingRangeAboutDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Unsere Polyhalle sowie unser 100m Schiesskeller runden unser Angebot ab. Der Zugang zu der Anlage ist an jedem Tag autonom möglich.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Our poly hall and 100m shooting range complete our offering. Access to the facility is autonomously possible every day.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "Notre hall poly et notre stand de tir de 100 m complètent notre offre. L'accès à l'installation est possible de manière autonome tous les jours.",
      },
    },
  },
  {
    key: 'ourHistory',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Unsere Geschichte',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Our History',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Notre Histoire',
      },
    },
  },
  {
    key: 'ourHistoryDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Wir sind bereits in der 3. Generation für Sie da.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'We have been here for you in the 3rd generation.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nous sommes déjà à votre service depuis 3 générations.',
      },
    },
  },
  {
    key: 'meetOurDepartmentHeads',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Treffen Sie unsere Abteilungsleiter und unsere Stellvertreter',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Meet our Department Heads and our Deputies',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Rencontrez nos chefs de département et nos adjoints',
      },
    },
  },
  {
    key: 'meetOurDepartmentHeadsDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Unsere Abteilungsleiter und Stellvertreter stehen Ihnen jederzeit zur Verfügung.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Our Department Heads and Deputies are always available to assist you.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Nos chefs de département et nos adjoints sont toujours disponibles pour vous aider.',
      },
    },
  },
  {
    key: 'apprenticeships',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Lehrstellen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Apprenticeships',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Apprentissages',
      },
    },
  },
  {
    key: 'apprenticeshipsDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Wir bilden regelmässig Büchsenmacherinnen und Büchsenmacher aus.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'We regularly train gunsmiths.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nous formons régulièrement des armuriers.',
      },
    },
  },
  {
    key: 'numberOfApprentices',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Anzahl Lehrlinge',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Number of apprentices',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Nombre d'apprentis",
      },
    },
  },
  {
    key: 'numberOfApprenticesDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Unser Team umfasst ständig zwei bis drei Lehrlinge. Wir stellen ungegefähr alle zwei Jahre einen neuen Lehrling oder neue Lehrtochter ein.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Our team consists of two to three apprentices at all times. We hire a new apprentice approximately every two years.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Notre équipe compte en permanence deux à trois apprentis. Nous engageons un nouvel apprenti environ tous les deux ans.',
      },
    },
  },
  {
    key: 'whatYouShouldBring',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Was du mitbringen solltest',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'What you should bring',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Ce que vous devriez apporter',
      },
    },
  },
  {
    key: 'whatYouShouldBringDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Der Büchsenmacherberuf hat ein facettenreiches Anforderungsprofil. Du solltest eine technische Affinität mitbringen - Schulfächer wie Mathematik, Physik und Werken liegen dir.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'The gunsmith profession has a multifaceted set of requirements. You should have a technical affinity - school subjects such as mathematics, physics and crafts suit you.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "Le métier de gunsmith a un ensemble d'exigences multifacettes. Vous devez avoir une affinité technique - des matières scolaires telles que les mathématiques, la physique et l'artisanat vous conviennent.",
      },
    },
  },
  {
    key: 'trialApprenticeship',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schnupperlehre',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Trial apprenticeship',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Apprentissage d'essai",
      },
    },
  },
  {
    key: 'trialApprenticeshipDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Wenn Du eine Schnupperlehre als Büchsenmacherin oder Büchsenmacher bei uns machen möchtest, dann geht auf die Seite des Schweizerischen Büchsenmacherverbandes. Dort findest Du den Fragebogen und die Bewerbung, die Du ausfüllen und uns per Mail senden kannst.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'If you would like to do a trial apprenticeship as a gunsmith with us, please visit the website of the Swiss Gunsmith Association. There you will find the questionnaire and the application form, which you can fill out and send to us by email.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "Si vous souhaitez effectuer un apprentissage d'essai en tant que gunsmith chez nous, veuillez visiter le site Web de l'Association suisse des gunsmiths. Vous y trouverez le questionnaire et le formulaire de candidature, que vous pouvez remplir et nous envoyer par e-mail.",
      },
    },
  },
  {
    key: 'jobs',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Jobs',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Jobs',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Emplois',
      },
    },
  },
  {
    key: 'noVacancies',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Aktuell keine Vakanzen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'No vacancies at the moment',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Aucune vacance pour le moment',
      },
    },
  },
  {
    key: 'jobsDescription',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Wir haben folgende Stellen zu besetzen:',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'We have the following positions to fill:',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nous avons les postes suivants à pourvoir :',
      },
    },
  },

  {
    key: 'noEntries',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Keine Einträge',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'No entries',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Pas d`entrées',
      },
    },
  },
  {
    key: 'promotion',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Aktionen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Promotions',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Promotions',
      },
    },
  },
  {
    key: 'newProducts',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Neuheiten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'New products',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nouveautés',
      },
    },
  },
  {
    key: 'matchingProducts',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Dazu passende Produkte',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Matching products',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Produits correspondants',
      },
    },
  },
  {
    key: 'showOriginalImage',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Originalbild anzeigen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Show original image',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Afficher l`image originale',
      },
    },
  },
  {
    key: 'showMore',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Mehr anzeigen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Show more',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Afficher plus',
      },
    },
  },
  {
    key: 'showLess',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Weniger anzeigen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Show less',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Afficher moins',
      },
    },
  },
  {
    key: 'tempCart',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Temporärer Warenkorb',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Temporary cart',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Panier temporaire',
      },
    },
  },
  {
    key: 'tempCartInfo',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Hierbei handelt es sich um einen temporären Warenkorb. Dieser wird nur auf diesem Gerät gespeichert und geht verloren, wenn Sie Ihre Cookies löschen oder einen anderen Browser verwenden. Um den Warenkorb zu speichern und alle Funktionen zu nutzen, melden Sie sich bitte an.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'This is a temporary cart. It is only stored on this device and will be lost if you clear your cookies or use a different browser. To save the cart and use all features, please log in.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "Il s'agit d'un panier temporaire. Il est uniquement stocké sur cet appareil et sera perdu si vous effacez vos cookies ou utilisez un autre navigateur. Pour enregistrer le panier et utiliser toutes les fonctionnalités, veuillez vous connecter.",
      },
    },
  },
  {
    key: 'voucher',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Gutscheine',
        [BbitTranslationType.SINGULAR]: 'Gutschein',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Vouchers',
        [BbitTranslationType.SINGULAR]: 'Voucher',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Bons',
        [BbitTranslationType.SINGULAR]: 'Bon',
      },
    },
  },
  {
    key: 'creditNote',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Gutschriften',
        [BbitTranslationType.SINGULAR]: 'Gutschrift',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Credit notes',
        [BbitTranslationType.SINGULAR]: 'Credit note',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Notes de crédit',
        [BbitTranslationType.SINGULAR]: 'Note de crédit',
      },
    },
  },
  {
    key: 'useCreditNote',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Gutschrift verwenden',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Use credit note',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Utiliser la note de crédit',
      },
    },
  },
  {
    key: 'companyFoundation',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Firmengründung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Company foundation',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Fondation de l'entreprise",
      },
    },
  },
  {
    key: 'companyFoundationText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Die Büchsenmacherei Wyss Waffen wurde 1960 von Robert Wyss gegründet.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'The gunsmithing company Wyss Waffen was founded in 1960 by Robert Wyss.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "L'armurerie Wyss Waffen a été fondée en 1960 par Robert Wyss.",
      },
    },
  },
  {
    key: 'firstApprentice',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Erster Lehrling',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'First apprentice',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Premier apprenti',
      },
    },
  },
  {
    key: 'firstApprenticeText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Firmengründer Robert Wyss bildete ebenfalls Lehrlinge aus. Die Aufgabe, junge Berufsleute auszubilden, ist für uns nach wie vor eine prioritäre Aufgabe. Stets sind ein- oder mehrere Büchsenmacher/innen bei uns in Ausbildung.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Company founder Robert Wyss also trained apprentices. Training young professionals remains a priority for us. We always have one or more gunsmiths in training with us.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "Le fondateur de l'entreprise, Robert Wyss, formait également des apprentis. La formation de jeunes professionnels reste pour nous une priorité. Nous avons toujours un ou plusieurs armuriers en formation chez nous.",
      },
    },
  },
  {
    key: 'moveToRuetschelgasse5',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Umzug an die Rütschelengasse 5',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Move to Ruetschelengasse 5',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Déménagement à la Rütschelengasse 5',
      },
    },
  },
  {
    key: 'moveToRuetschelgasse5Text',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Von der Emmentalstrasse zog der Betrieb 1968 an die Rütschelengasse 5 in Burgdorf um.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'The gunsmithing company Wyss Waffen moved from Emmentalstrasse to Rütschelengasse 5 in Burgdorf in 1968.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "L'armurerie Wyss Waffen a déménagé de l'Emmentalstrasse à la Rütschelengasse 5 à Burgdorf en 1968.",
      },
    },
  },
  {
    key: 'handoverToSecondGeneration',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Übergabe an 2. Generation',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Handover to 2nd Generation',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Transmission à la deuxième génération',
      },
    },
  },
  {
    key: 'handoverToSecondGenerationText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Robert Wyss übergibt das Geschäft seinem Sohn Daniel Wyss.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Robert Wyss hands over the business to his son Daniel Wyss.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Robert Wyss cède l'entreprise à son fils Daniel Wyss.",
      },
    },
  },
  {
    key: 'moveToKirchbergstrasse186a',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Umzug an die Kirchbergstrasse 186a',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Move to Kirchbergstrasse 186a',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Déménagement à la Kirchbergstrasse 186a',
      },
    },
  },
  {
    key: 'moveToKirchbergstrasse186aText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          '2021 konnte der lang ersehnte Neubau an der Kirchbergstrasse 186a realisiert und bezogen werden, wodurch ein Komplettangebot rund um den Schiesssport und die Jagd entstand.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'In 2021, the long-awaited new building at Kirchbergstrasse 186a was completed and occupied, creating a comprehensive offering for shooting sports and hunting.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'En 2021, le nouveau bâtiment tant attendu à la Kirchbergstrasse 186a a été achevé et occupé, créant une offre complète pour les sports de tir et la chasse.',
      },
    },
  },
  {
    key: 'renamedWwbAg',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Umbenennung in WWB AG',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Renaming to WWB AG',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Renommage en WWB AG',
      },
    },
  },
  {
    key: 'renamedWwbAgText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Die Einzelfirma wird in eine Aktiengesellschaft umstrukturiert und dabei in WWB AG umbenannt.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'The sole proprietorship will be restructured into a corporation and renamed WWB AG.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'La société individuelle sera restructurée en une société par actions et renommée WWB AG.',
      },
    },
  },
  {
    key: 'managingDirector',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Geschäftsleiter, Leiter Grosshandel',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Managing Director, Head of Wholesale',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Directeur général, responsable de la vente en gros',
      },
    },
  },
  {
    key: 'deputyManagingDirector',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stv. Geschäftsleiter, Leiter Detailhandel',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Deputy Managing Director, Head of Retail',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Directeur général adjoint, responsable de la vente au détail',
      },
    },
  },
  {
    key: 'headOfAdministration',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Leiterin Administration',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Head of Administration',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Responsable administrative',
      },
    },
  },
  {
    key: 'headOfProduction',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Leiter Produktion',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Head of Production',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Directeur de la production',
      },
    },
  },
  {
    key: 'workshopManager',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Leiter Werkstatt',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Workshop Manager',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Directeur de l'atelier",
      },
    },
  },
  {
    key: 'headOfShootingRanges',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Leiter Schiessanlagen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Head of Shooting Ranges',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Directeur des installations de tir',
      },
    },
  },
  {
    key: 'deputyWorkshopManager',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stv. Werkstattleiter',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Deputy Workshop Manager',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Directeur adjoint de l'atelier",
      },
    },
  },
  {
    key: 'deputyHeadOfProduction',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stv. Leiter Produktion',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Deputy Head of Production',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Directeur adjoint de la production',
      },
    },
  },
  {
    key: 'onTheFirstFloor',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Im 1. OG',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'On the 1st floor',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Au 1er étage',
      },
    },
  },
  {
    key: 'polyHall',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Polyhalle',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Poly hall',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Poly hall',
      },
    },
  },
  {
    key: 'polyHallText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Statisch und dynamisch nutzbar. Als zusätzliches Equipment sind Fall- und Schwenkziele aus Kunststoff (nicht splitternd), div. Barrikaden & Hindernisse sowie mobile Kugelfänge vorhanden.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Static and dynamic use. Additional equipment includes fall and swivel targets made of plastic (non-splintering), various barricades & obstacles, and mobile bullet traps.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "Utilisable de manière statique et dynamique. Des cibles tombantes et pivotantes en plastique (incassables), diverses barricades et obstacles ainsi que des pare-balles mobiles sont disponibles en tant qu'équipement supplémentaire.",
      },
    },
  },
  {
    key: 'individuallyControllableTurntables',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Individuell steuerbare Zugdrehscheiben',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Individually controllable turntables',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Tables tournantes individuellement contrôlables',
      },
    },
  },
  {
    key: 'maximumDistance',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Maximale Distanz',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Maximum Distance',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Distance maximale',
      },
    },
  },
  {
    key: 'maximumApprovalMainBulletTrap',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Maximale Zulassung Hauptkugelfang',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Maximum approval main bullet trap',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Approbation maximale du piège à balles principal',
      },
    },
  },
  {
    key: 'barricadesAndObstacles',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Barrikaden & Hindernisse',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Barricades & obstacles',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Barricades & obstacles',
      },
    },
  },
  {
    key: 'onTheFirstBasementLevel',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Im 1. UG',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'On the 1st basement level',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Au 1er sous-sol',
      },
    },
  },
  {
    key: 'shootingcellar',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schiesskeller',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Shooting cellar',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Salle de tir',
      },
    },
  },
  {
    key: 'shootingCellarText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Statisch nutzbar, ideal zum Training von Langwaffen.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Static use, ideal for training long guns.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Utilisation statique, idéale pour l'entraînement des armes longues.",
      },
    },
  },
  {
    key: 'maximumDistanceLeft',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Maximale Distanz. Maximale Zulassung Kugelfang 7’000 J, mit Spezialbewilligung bis 14’500 J',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Maximum distance. Maximum approval bullet trap 7,000 J, with special permission up to 14,500 J',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Distance maximale. Approbation maximale du piège à balles 7’000 J, avec autorisation spéciale jusqu’à 14’500 J',
      },
    },
  },
  {
    key: 'left100m',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Links: 100m',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Left: 100m',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Gauche: 100m',
      },
    },
  },
  {
    key: 'maximumDistanceRight',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Maximale Distanz. Maximale Zulassung Kugelfang 5’000 J',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Maximum distance. Maximum approval bullet trap 5,000 J',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Distance maximale. Approbation maximale du piège à balles 5’000 J',
      },
    },
  },
  {
    key: 'right25m',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Rechts: 25m',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Right: 25m',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Droite: 25m',
      },
    },
  },
  {
    key: 'trainingroom',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schulungsraum',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Training room',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Salle de formation',
      },
    },
  },
  {
    key: 'trainingRoomText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Als Auffrischung bei zu trockener Theorie befindet sich daneben ein Aufenthaltsraum mit Snackautomat & Kaffeemaschine.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'As a refresher in case of overly dry theory, there is a lounge area with a snack machine & coffee machine next door.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Pour se détendre après une théorie trop aride, il y a à côté une salle de repos avec un distributeur automatique de snacks et une machine à café. ',
      },
    },
  },
  {
    key: 'placesForPeopleIncludingInstructor',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Plätze für Personen inklusive Instruktor',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Places for people including instructor',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Places pour les personnes, y compris l'instructeur",
      },
    },
  },
  {
    key: 'ledTvText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'LED Fernseher für Präsentationen - koppelbar über WLAN oder Bluetooth',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'LED TV for presentations - connectable via WLAN or Bluetooth',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'TV LED pour les présentations - connectable via WLAN ou Bluetooth',
      },
    },
  },
  {
    key: 'youCanRentFromUs',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bei uns können Sie mieten',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'You can rent from us',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Vous pouvez louer chez nous',
      },
    },
  },
  {
    key: 'rentalWeapons',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Mietwaffen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Rental weapons',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Armes à louer',
      },
    },
  },
  {
    key: 'rentalWeaponsText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Verfügbar während der Geschäftsöffnungszeit oder auf Anfrage für Anlässe und Kurse. Voraussetzung: Sie müssen nachweisen, dass Sie die Bedingungen zum Erhalt eines Waffenerwerbsscheines erfüllen.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Available during business hours or upon request for events and courses. Prerequisite: You must prove that you meet the requirements for obtaining a weapon acquisition permit.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "Disponible pendant les heures d'ouverture ou sur demande pour des événements et des cours. Condition préalable : vous devez prouver que vous remplissez les conditions pour obtenir un permis d'acquisition d'armes.",
      },
    },
  },
  {
    key: 'longGunsText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Langwaffen nahmhafter Hersteller wie Hänel, Steyr, Schmeisser, etc.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Long guns from renowned manufacturers such as Hänel, Steyr, Schmeisser, etc.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Fusils longs de fabricants renommés tels que Hänel, Steyr, Schmeisser, etc.',
      },
    },
  },
  {
    key: 'pistolText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Pistolen / Revolver von CZ, Walther, Beretta, etc.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Pistols / Revolvers from CZ, Walther, Beretta, etc.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Pistolets / Revolvers de CZ, Walther, Beretta, etc.',
      },
    },
  },
  {
    key: 'variousCalibers',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Verschiedene Kaliber',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Various calibers',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Divers calibres',
      },
    },
  },
  {
    key: 'corporateEvents',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Firmenanlässe & Events',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Corporate events & events',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Événements d'entreprise & événements",
      },
    },
  },
  {
    key: 'corporateEventsText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Wir bieten Ihnen die Möglichkeit, Ihren Firmenanlass oder Ihr Vereinsfest bei uns durchzuführen. Wir stellen Ihnen die Schiessanlage, das Material und das Personal zur Verfügung. Sie können sich auf das Wesentliche konzentrieren und Ihre Veranstaltung geniessen.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'We offer you the opportunity to hold your corporate event or club celebration with us. We provide you with the shooting range, the equipment, and the staff. You can focus on what matters and enjoy your event.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          "Nous vous offrons la possibilité d'organiser votre événement d'entreprise ou votre fête associative chez nous. Nous mettons à votre disposition le stand de tir, le matériel et le personnel. Vous pouvez ainsi vous concentrer sur l'essentiel et profiter pleinement de votre événement.",
      },
    },
  },
  {
    key: 'upTo40',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'bis ca. 40',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'up to approx. 40',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "jusqu'à environ 40",
      },
    },
  },
  {
    key: 'participantsPerEvent',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Teilnehmer pro Event',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Participants per event',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Participants par événement',
      },
    },
  },
  {
    key: 'withOrWithout',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'mit oder ohne',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'with or without',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'avec ou sans',
      },
    },
  },
  {
    key: 'companyTour',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Firmenführung',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Company tour',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Visite d'entreprise",
      },
    },
  },
  {
    key: 'weAlsoOffer',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Wir bieten zudem',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'We also offer',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Nous offrons également',
      },
    },
  },
  {
    key: 'shootingCoursesAndTrainings',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schiesskurse & Ausbildungen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Shooting courses & training',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Cours de tir & formations',
      },
    },
  },
  {
    key: 'shootingCoursesAndTrainingsText',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Individuell auf Kundenwunsch erstellte Privat- und Gruppenkurse für alle Ausbildungsstufen - von Einsteigerkursen bis zum Taktisch bewegten schiessen ist alles möglich.',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'Custom private and group courses tailored to customer requirements for all skill levels - from beginner courses to tactical shooting on the move, everything is possible.',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Cours privés et collectifs personnalisés selon les souhaits des clients pour tous les niveaux de formation : des cours pour débutants au tir tactique, tout est possible.',
      },
    },
  },
  {
    key: 'alreadyConductedPrivateAndGroupCourses',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Bereits durchgeführte Privat- und Gruppenkurse',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Completed private and group courses',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Cours privés et collectifs déjà réalisés',
      },
    },
  },
  {
    key: 'participantsPerCourse',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Teilnehmer pro Kurs',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Participants per course',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Participants par cours',
      },
    },
  },
  {
    key: 'selectionOfCourseInstructors',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Auswahl an Kursleiter',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Selection of course instructors',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Sélection des formateurs',
      },
    },
  },
  {
    key: 'training',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Training',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Training',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Formation',
      },
    },
  },
  {
    key: 'safety',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Sicherheit',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Safety',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Sécurité',
      },
    },
  },
  {
    key: 'equipment',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Equipment',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Equipment',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Équipement',
      },
    },
  },
  {
    key: 'operations',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Operations',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Operations',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Opérations',
      },
    },
  },
  {
    key: 'combatShooting',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Combatschiessen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Combat shooting',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Tir de combat',
      },
    },
  },
  {
    key: 'idpa',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'IDPA',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'IDPA',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'IDPA',
      },
    },
  },
  {
    key: 'firearmsTrainingWithShortAndLongGuns',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schiessausbildung an Kurz- und Langwaffen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Firearms training with short and long guns',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Formation aux armes à feu avec des armes courtes et longues',
      },
    },
  },
  {
    key: 'schoolForSportShooting',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schule für Sportschiessen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'School for sport shooting',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'École de tir sportif',
      },
    },
  },
  {
    key: 'schoolForSportShooting',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schule für Sportschiessen',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'School for sport shooting',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'École de tir sportif',
      },
    },
  },
  {
    key: 'gunsmithScc',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Büchsenmacher EFZ',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Gunsmith SCC',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Büchsenmacher CFC',
      },
    },
  },
  {
    key: 'captainInTheSwissArmy',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Hauptmann Schweizer Armee',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Captain in the Swiss Army',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Capitaine dans l'armée suisse",
      },
    },
  },
  {
    key: 'assaultRifleInstructorLevelTwo',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Stgw Ausbilder Stufe II',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'AR instructor level II',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: "Instructeur de fusil d'assaut de niveau II",
      },
    },
  },
  {
    key: 'pistolInstructorLevelTwo',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Pistolen Ausbilder Stufe II',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Pistol instructor level II',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Instructeur de pistolet de niveau II',
      },
    },
  },
  {
    key: 'tourniquetInstructor',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Tourniquet Ausbilder',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Tourniquet instructor',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Instructeur de garrot',
      },
    },
  },
  {
    key: 'irritantSprayDeviceInstructor',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Reizstoffsprühgerät Ausbilder',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Irritant spray device instructor',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Instructeur de spray irritant',
      },
    },
  },
  {
    key: 'youthShootingInstructor',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Jungschützenleiter',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Youth shooting instructor',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Instructeur de tir pour la jeunesse',
      },
    },
  },
  {
    key: 'rifleMaster',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Schütznenmeister',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Rifle master',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Maître tireur',
      },
    },
  },
  {
    key: 'masterHuntsman',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Jagdschützenmeister',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Master huntsman',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Maître chasseur',
      },
    },
  },
  {
    key: 'active300mCompetitor',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]: 'Aktiver 300m Schütze',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]: 'Active 300m competitor',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]: 'Concurrent actif à 300 m',
      },
    },
  },
  {
    key: 'internationalMilitaryShootingCompetitions',
    text: {
      [BbitLanguage.DE_CH]: {
        [BbitTranslationType.PLURAL]:
          'Internationale Militärschiesswettkämpfe (Auszeichnungen: M16 Expert, LMG Marksman, Pistol & SMG Sharpshooter)',
      },
      [BbitLanguage.EN_US]: {
        [BbitTranslationType.PLURAL]:
          'International military shooting competitions (awards: M16 Expert, LMG Marksman, Pistol & SMG Sharpshooter)',
      },
      [BbitLanguage.FR_CH]: {
        [BbitTranslationType.PLURAL]:
          'Concours internationaux de tir militaire (récompenses : expert M16, tireur LMG, tireur de pistolet et SMG)',
      },
    },
  },
];
